
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, matchPath } from 'react-router-dom';
import { Tab, Nav, Row, Col, Form } from 'react-bootstrap';
import EquipmentGroupForm from './EquipmentGroupForm';
import EquipmentGroupFilter from './EquipmentGroupFilter';
import EquipmentGroupCard from './EquipmentGroupCard';
import { SubNav } from '../layout/submenu';
import { Modal } from '../widgets';
import { searchWord, isToday, usePermission, getQueryParams, isDeveloper } from '../../helpers/common';
import { getSearchQueryData } from '../../helpers/session';
import { getDrawingInstance } from '../map/geo/DrawingControl';
import { deleteEquipmentGroup, getEquipmentGroupList, selectedEquipmentGroup, setSelectedEG } from '../../actions/equipment-group';
import { filterMapEgList, clearMapFilters, refreshMapData } from '../../actions/map';
import { planAnalyzeInfo, egAnalyzeInfo, analyzeParams } from '../../actions/analyze';
import {
  EQUIPMENT_TRUCK, EQUIPMENT_TRACTOR,
  EQUIPMENT_SELF_PROPELLED, EQUIPMENT_PERSON
} from '../../constants';

const EquipmentGroupSubList = (props) => {

  const selectedPlanType = useSelector(state => state.plan.selectedPlanType);
  const isAllPlan = useSelector(state => state.plan.isSelectAllPlan);
  const regionsList = useSelector(state => state.geo.regionsList);
  const search = useSelector(state => state.analyze.searchParams);
  const equipmentGroup = useSelector(state => state.equipmentGroup);

  const {
    isRequesting,
    equipmentGroupList,
    selectedEquipmentGroup: selectedEG,
    selectedEGlist
  } = equipmentGroup;

  const { range } = search;

  const dispatch = useDispatch();
  const tabs = [
    { id: 1, label: "All", equimentTypeIds: null },
    { id: 2, label: "Tractors", equimentTypeIds: [EQUIPMENT_TRACTOR] },
    { id: 3, label: "Trucks", equimentTypeIds: [EQUIPMENT_TRUCK] },
    { id: 4, label: "Operators", equimentTypeIds: [EQUIPMENT_PERSON] },
    { id: 5, label: "Others", equimentTypeIds: [EQUIPMENT_SELF_PROPELLED] }
  ];

  const initialState = {
    farmId: 0,
    activeTab: 1,
    searchText: '',
    selectedIds: [],
    filterIds: null,
    deleteId: null,
    deleteModal: false,
    egName: '',
    rootUrl: '',
    modal: false,
    equipmentGroupInfo: null,
    isEditMode: false,
    editKey: 0,
    firstRequest: false,
    prevSelectedID: '',
    searchQuery: null,
    isShowAll: false
  };

  const [state, setState] = useState(initialState);
  const searchInput = React.createRef()
  const drawing = getDrawingInstance();
  const { activeTab, rootUrl, searchText } = state;
  const today = isToday(range);
  const allow = usePermission();
  const isAllowDelete = allow("equipment-group", "delete");

  const getMatch = () => {
    return matchPath(props.history.location.pathname, {
      path: `${props.match.path}/:egId?`,
      exact: false,
      strict: false
    });
  }
  const getEgList = (isShowAll = false) => {
    const { farmId } = props.match.params;
    dispatch(getEquipmentGroupList({
      farmId, crew: 1, device: 1,
      ...(!isShowAll && !isAllPlan) && { selectedPlanType: selectedPlanType }
    }));
  }
  const setMapInfo = (selectedIds, filterIds) => {
    if (typeof filterIds === 'undefined') filterIds = state.filterIds;

    let currSelectedIds = equipmentGroupList
      .filter(e => selectedIds.indexOf(e.equipment_group_uuid) >= 0)
      .map(e => e.equipment_group_uuid);

    if (Array.isArray(filterIds))
      currSelectedIds = filterIds.filter(id => currSelectedIds.indexOf(id) >= 0);

    if (currSelectedIds.length === 1) {
      const findItems = equipmentGroupList.filter(e => e.equipment_group_uuid === currSelectedIds[0]);
      if (findItems.length > 0) {
        const item = findItems[0];
        const crewId = item.crews && item.crews.length > 0 ? item.crews[item.crews.length - 1].crew_uuid : null;
        dispatch(egAnalyzeInfo(crewId,
          item.crews,
          item.equipment_group_uuid,
          item.equipment_group_name,
          item.vehicle.is_truck,
          item.primary_category_id
        ));
        dispatch(filterMapEgList({ egIds: [item.equipment_group_uuid] }));
      } else {
        dispatch(filterMapEgList({ egIds: [] }));
        dispatch(planAnalyzeInfo(state.farmId));
      }
    }
    else if (currSelectedIds.length > 0 && currSelectedIds.length === equipmentGroupList.length) {
      dispatch(filterMapEgList({ egIds: currSelectedIds }));
      dispatch(planAnalyzeInfo(state.farmId));
    }
    else if (currSelectedIds.length > 0) {
      dispatch(filterMapEgList({ egIds: currSelectedIds }));
      dispatch(analyzeParams({ show: false, disabled: true }));
    }
    else if (currSelectedIds.length === 0) {
      dispatch(filterMapEgList({ egIds: [] }));
      dispatch(planAnalyzeInfo(state.farmId));
    }
  }
  const toggle = (tab) => {
    if (activeTab !== tab) setState({ ...state, activeTab: tab });
  }
  const handleSearchBox = (searchText) => {
    setState({ ...state, searchText });
  }
  const handleDelete = (id, name) => {
    setState({ ...state, deleteEgId: id, egName: name, deleteModal: true });
  }
  const handleDeleteConfim = () => {
    dispatch(deleteEquipmentGroup({
      farm_uuid: state.farmId,
      equipment_group_uuid: state.deleteEgId
    }, () => dispatch(refreshMapData())));
  }
  const getFilteredList = (isSearchText) => {
    let filteredList = equipmentGroupList;
    const { filterIds } = state;
    const parsedActiveTab = parseInt(activeTab);
    const findTabs = tabs.filter(e => e.id === parsedActiveTab);
    const equipmentTypeIds = (findTabs.length > 0) ? findTabs[0].equimentTypeIds : null;

    if (equipmentTypeIds) filteredList = filteredList.filter(e => equipmentTypeIds.indexOf(e.vehicle.equipment_type_id) >= 0);
    if (filterIds) filteredList = filteredList.filter(e => filterIds.indexOf(e.equipment_group_uuid) >= 0);

    const selectedIds = filteredList
      .map(e => e.equipment_group_uuid)
      .filter(id => (state.selectedIds && state.selectedIds.indexOf(id) >= 0));

    if (isSearchText) {
      const { searchText } = state;
      const isSearchTextMatched = value => searchWord(value, searchText);
      if (searchText && searchText.trim().length > 0) filteredList = filteredList.filter(e => {
        return isSearchTextMatched(e.equipment_group_name) ||
          isSearchTextMatched(e.primary_category_name) ||
          isSearchTextMatched(e.vehicle.name) ||
          isSearchTextMatched(e.implement.name) ||
          isSearchTextMatched(e.operator.name) ||
          isSearchTextMatched(e.phone_device.name);
      });
    }
    const isSelectAll = (filteredList.length === selectedIds.length);
    return { egList: filteredList, selectedIds, isSelectAll };
  }
  const handleSelect = (id, event) => {
    const { checked } = event.target;
    const { selectedIds } = state;

    if (id === -1) {
      const { egList } = getFilteredList(true);
      if (checked) {
        egList.forEach(e => {
          if (selectedIds && selectedIds.indexOf(e.equipment_group_uuid) < 0)
            selectedIds.push(e.equipment_group_uuid);
        });
      } else {
        egList.forEach(e => {
          const indexOf = selectedIds.indexOf(e.equipment_group_uuid);
          if (indexOf >= 0) selectedIds.splice(indexOf, 1);
        });
      }
    } else {
      const indexOf = selectedIds.indexOf(id);
      if (checked && indexOf < 0) {
        selectedIds.push(id);
      }
      else if (!checked && indexOf >= 0) {
        const id = selectedIds[indexOf];
        if (selectedEG && id === selectedEG.id) {
          setState({ ...state, prevSelectedID: '' });
          dispatch(selectedEquipmentGroup(null));
        }
        selectedIds.splice(indexOf, 1);
      }
    }

    setState({ ...state, selectedIds });
    setMapInfo(selectedIds);
    dispatch(setSelectedEG(selectedIds));
  }

  const handleFilter = (filterIds) => {
    if (Array.isArray(filterIds)) {
      const selectedIds = filterIds.filter(id => (state.selectedIds.indexOf(id) >= 0));
      setMapInfo(selectedIds, filterIds);
    } else if (state.filterIds && state.filterIds.length > 0 && filterIds === null)
      setMapInfo(state.selectedIds, filterIds);

    setState({ ...state, filterIds });
  }
  useEffect(() => {
    if (drawing && regionsList && regionsList.length > 0) {
      drawing.showShapeGroups(
        regionsList.filter(e => e.geo_region_uuid).map((e) => e.geo_region_uuid),
        true
      );
    }

    let newState = {}
    if (search || selectedPlanType || isAllPlan) {
      getEgList();
      if (isAllPlan) newState = { ...newState, isShowAll: isAllPlan };
    }

    if (selectedEG && selectedEG.id) {
      const item = selectedEG;
      const crewId = item.crews && item.crews.length > 0 ? item.crews[item.crews.length - 1].crew_uuid : null;
      newState = { ...newState, selectedIds: [item.id], prevSelectedID: item.id }
      dispatch(egAnalyzeInfo(crewId, item.crews, item.id, item.value, item.isTruck));
      dispatch(filterMapEgList({ egIds: [item.id] }));
    } else {
      if (selectedEGlist !== state.selectedIds) {
        newState = { ...newState, selectedIds: selectedEGlist }
      }

      // check the is all selected already
      if (!isRequesting && equipmentGroupList) {
        if (state.firstRequest) {
          // const selectedIds = this.props.equipmentGroupList.map(e => e.equipment_group_uuid);
          // this.setState({ selectedIds, firstRequest: false });
          // this.setMapInfo(selectedIds);
        }
        else if (state.selectedIds.length === equipmentGroupList.length) {//check
          const notMatched = equipmentGroupList.filter(e => state.selectedIds.indexOf(e.equipment_group_uuid) < 0);
          if (notMatched.length === 0) {
            const selectedIds = equipmentGroupList.map(e => e.equipment_group_uuid);
            newState = { ...newState, selectedIds }
            setMapInfo(selectedIds);
          }
        } else setMapInfo(state.selectedIds);
      }

      if (!isRequesting && state.searchQuery) {
        const { source_equipment_group_uuid, target_equipment_group_uuid } = state.searchQuery;
        const selectedId = source_equipment_group_uuid ? source_equipment_group_uuid : target_equipment_group_uuid ? target_equipment_group_uuid : null;
        if (selectedId) {
          newState = { ...newState, selectedIds: [selectedId] }
          setMapInfo([selectedId]);
          dispatch(setSelectedEG([selectedId]));
          newState = { ...newState, searchQuery: null }
        }
      }
    }
    setState({ ...state, ...newState });
  }, [
    search,
    isAllPlan,
    selectedPlanType,
  ]);

  useEffect(() => {
    searchInput.current.focus();
    const { farmId } = props.match.params;
    const match = getMatch();
    let selectedIds = [];
    if (match && match.params && match.params.egId)
      selectedIds = match.params.egId.split(",");

    if (range) getEgList();

    let newState = {
      ...state,
      farmId,
      selectedIds,
      rootUrl: `/home/farm/${farmId}/eg`,
      firstRequest: true
    }

    if (selectedEGlist && selectedEGlist.length > 0) {
      newState = { ...newState, selectedIds: selectedEGlist }
      setMapInfo(selectedEGlist);
    }
    else setMapInfo(selectedIds);

    const queryParameters = getQueryParams();
    const searchQuery = getSearchQueryData(queryParameters['searchId']);
    if (searchQuery) {
      newState = { ...newState, searchQuery }
    }
    if (isAllPlan) {
      newState = { ...newState, isShowAll: isAllPlan };
    }
    setState(newState);
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSelectedEG(state.selectedIds));
      dispatch(selectedEquipmentGroup(null));
      dispatch(clearMapFilters());
    }
  }, []);

  const { egList, selectedIds, isSelectAll } = getFilteredList(true);

  return (<SubNav>
    <SubNav.Subheader>
      <div className='title-container'>
        <aside className='section-title'>
          <NavLink to={`${rootUrl}/list`}>
            Equipment Groups {equipmentGroupList.length > 0 ? `(${equipmentGroupList.length})` : ''}
            <i className="fa fa-angle-right section-right-arrow"></i>
          </NavLink>
        </aside>
        <aside className='section-icon-container'>
          <NavLink
            className="m-0 p-0 btn-kanban-eg"
            to={`${rootUrl}/kanban`}
            title="Manage Equipment Groups">
            <i className="fa fa-th" aria-hidden="true" />
          </NavLink>
          <NavLink
            className="m-0 p-0 btn-ganttchart"
            to={`${rootUrl}/ganttchart`}
            title="Gantt Chart">
            <i className="fa fa-sliders" aria-hidden="true" />
          </NavLink>
          {
            isDeveloper() ? <span
              title="Location Events"
              style={{ cursor: "pointer" }}
              onClick={() => window.open(`/home/farm/${state.farmId}/eg-region-location`, "_blank")}
            >
              <i className="fa fa-location-arrow" aria-hidden="true" />
            </span> : null
          }
        </aside>
      </div>
    </SubNav.Subheader>

    <SubNav.SearchBox
      ref={searchInput}
      placeholder="EG Name, Vehicle, Implement, Operator, Device"
      value={searchText}
      onChange={e => handleSearchBox(e.target.value)}
      onClear={() => handleSearchBox("")}
    />

    <Tab.Container defaultActiveKey="1">
      <Nav variant="tabs" >
        {tabs.map(e =>
          <Nav.Item key={e.id}>
            <Nav.Link
              eventKey={e.id}
              onClick={() => toggle(e.id)}>
              {e.label}
            </Nav.Link>
          </Nav.Item>
        )}
        <Nav.Item>
          <EquipmentGroupFilter
            equipmentGroupList={equipmentGroupList}
            onFilter={handleFilter}
          />
        </Nav.Item>
      </Nav>

      <Tab.Content>
        <Tab.Pane eventKey={activeTab} className="scroll-bar-2">
          {isRequesting && <SubNav.Loading />}
          {!isRequesting && egList.length === 0 && <SubNav.NotFound />}
          {!isRequesting && egList.length > 0 &&

            <SubNav.List>
              <Row className="p-0 m-0 pt-1 pb-2">
                <Col lg={1} md={1} sm={1} className="p-0 m-0">
                  <SubNav.Checkbox
                    checked={isSelectAll}
                    onChange={(e) => handleSelect(-1, e)}
                  />
                </Col>
                <Col lg={7} md={7} sm={7} className="p-0 m-0">
                  <SubNav.Link to={props.match.url}>
                    Select all
                  </SubNav.Link>
                </Col>
                {!isAllPlan && <Col lg={4} md={4} sm={4} className="p-0 m-0">
                  <Form className='crew-show-all'>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label="Show All"
                      checked={state.isShowAll}
                      disabled={isAllPlan}
                      onChange={e => {
                        getEgList(e.target.checked);
                        setState({ ...state, isShowAll: e.target.checked });
                      }}
                    />
                  </Form>
                </Col>}
              </Row>
              {egList.map((e, i) => {
                const selected = (selectedIds.indexOf(e.equipment_group_uuid) >= 0);
                return <EquipmentGroupCard
                  key={e.equipment_group_uuid}
                  item={e}
                  selected={selected}
                  isToday={today}
                  isAllowDelete={isAllowDelete}
                  onSelect={handleSelect}
                  onClickDelete={handleDelete}
                />;
              })}

            </SubNav.List>}
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>

    {state.modal &&
      <EquipmentGroupForm
        match={props.match}
        isOpen={state.modal}
        onHide={() => { setState({ ...state, modal: !state.modal }); }}
        isEditMode={state.isEditMode}
        editKey={state.editKey}
        equipmentGroupInfo={state.equipmentGroupInfo} />}

    <Modal.Confirm
      show={state.deleteModal}
      onConfirm={handleDeleteConfim}
      onHide={() => setState({ ...state, deleteModal: !state.deleteModal })}
      iconClassName="fa fa-trash"
      body={`Do you really want to delete these ${state.egName}?`}
    />
  </SubNav>

  );
}
export default EquipmentGroupSubList;